import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "reviews-section my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_4 = {
    key: 0,
    class: "rating-summary"
};
const _hoisted_5 = { class: "avg" };
const _hoisted_6 = { class: "count text-muted" };
const _hoisted_7 = {
    key: 0,
    class: "reviews-list"
};
const _hoisted_8 = { class: "review-header" };
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "date text-muted" };
const _hoisted_11 = { class: "mb-0 text-secondary" };
const _hoisted_12 = {
    key: 1,
    class: "text-muted"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReviewsSection',
    props: {
        reviews: {},
        summary: {}
    },
    setup(__props) {
        const props = __props;
        const formatDate = (iso) => {
            const d = new Date(iso);
            return d.toLocaleDateString();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "h5 m-0" }, [
                            _createElementVNode("i", { class: "fas fa-star me-2 text-warning" }),
                            _createTextVNode("Opiniones de huéspedes")
                        ], -1)),
                        (_ctx.summary)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.summary.average.toFixed(1)), 1),
                                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "muted" }, "/ 5", -1)),
                                _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.summary.count) + " reseñas)", 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.reviews && _ctx.reviews.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (r) => {
                                return (_openBlock(), _createElementBlock("article", {
                                    key: r.id,
                                    class: "review-item"
                                }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("strong", null, _toDisplayString(r.author), 1),
                                        _createElementVNode("span", {
                                            class: "stars",
                                            title: `${r.rating}/5`
                                        }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                                                return _createElementVNode("i", {
                                                    key: n,
                                                    class: _normalizeClass(n <= r.rating ? 'fas fa-star text-warning' : 'far fa-star text-warning')
                                                }, null, 2);
                                            }), 64))
                                        ], 8, _hoisted_9),
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(formatDate(r.date)), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_11, _toDisplayString(r.text), 1)
                                ]));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, "Aún no hay reseñas."))
                ])
            ]));
        };
    }
});
